import React from 'react';

export default class Avatar extends React.PureComponent {
  handleImageUpload = (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      const { setAvatar } = this.props;
      setAvatar(reader.result);
    };

    reader.readAsDataURL(file);
  };

  render() {
    const { avatar, initials } = this.props;

    return [
      <div className="c-input__wrapper" key={1}>
        <span className="c-input__label">Vaša fotografia &mdash; Ideálna fotografia je v štvorcovom pomere strán a formáte JPEG alebo PNG.</span>
        <div className="photo__wrapper">
          <div className="photo">
            {avatar
              ? <span className="photo__img photo__img--fixed-size">
                  <span className="avatar avatar--bg" style={{ backgroundImage: `url(${avatar})`, width: '90px', height: '90px', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} />
                </span>
              : <span className="photo__img">
                  <span className="initials">
                    <span className="initials__chars">{initials}</span>
                  </span>
                </span>
            }
          </div>
        </div>
      </div>,

      <label className="campaign-edit__button campaign-edit__button--photo c-button" key={2}>
        <span className="c-button__content">Nahrať vlastnú fotografiu</span>
        <input
          style={{
            width: 0.1,
            height: 0.1,
            position: 'absolute',
            opacity: 0,
            zIndex: -1,
            overflow: 'hidden'
          }}
          type="file"
          accept=".png, .jpg, .jpeg"
          onChange={this.handleImageUpload}
        />
      </label>
    ];
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/profileEditor/Avatar.js